import { Component, OnInit } from '@angular/core';
import { MixedLoyaltyQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';
@Component({
  selector: 'fgb-rewards-page',
  templateUrl: './rewards-page.component.html',
  styleUrls: ['./rewards-page.component.scss'],
})
export class RewardsPageComponent implements OnInit {
  populations = Populations;

  constructor(private mixedLoyaltyQuery: MixedLoyaltyQuery) {}
  showOffCanvas: boolean = false;

  ngOnInit() {
    this.mixedLoyaltyQuery.selectFavouriteMixedLoyaltyItems().subscribe().unsubscribe();
  }
}
